import { Button, Grid, IconButton, Tooltip } from "@material-ui/core";
import { Add, Delete } from "@material-ui/icons";
import React from "react";
import { FormSection } from "redux-form";
import { FlexGridItem, FlexNumberField, FlexTextField } from "./form_utility";

class UnicefOrderNoForm extends React.Component<any, any>{
    constructor(props: any) {
        super(props);
        this.state = {
        };
    }

    public componentDidUpdate(prevProps: any) {
        // const { fields, isToasterVisible, disableForm } = this.props;
        // console.log("PROPS", this.props);
        // console.log("fields", fields);
    }

    private addEmptyUnicefNos = () => {
        const { fields } = this.props;
        fields.push({});
    }

    public render() {
        const { fields, disableForm } = this.props;
        return (
            <>
                <FlexGridItem xs={6}>
                    <h4>Unicef Order :</h4>
                    <div style={{ padding: "10px 5px" }}>
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={this.addEmptyUnicefNos}
                            disabled={disableForm}
                        >
                            Add
                            <Add />
                        </Button>
                    </div></FlexGridItem>
                <FlexGridItem xs={6}></FlexGridItem>
                {fields.map((member: any, index: any) => {
                    return (
                        <FormSection key={index} name={member}>
                            <FlexGridItem xs={6}>
                                <Grid container={true} spacing={2}>
                                    <FlexGridItem xs={4}>
                                        <FlexNumberField
                                            name="orderNo"
                                            label="Order No."
                                            disabled={disableForm}
                                            inputProps={{ min: 0 }}
                                        />
                                    </FlexGridItem>
                                    <FlexGridItem xs={4}>
                                        <FlexNumberField
                                            name="itemNo"
                                            label="Item No."
                                            disabled={disableForm}
                                            inputProps={{ min: 0 }}
                                        />
                                    </FlexGridItem>
                                    <FlexGridItem xs={4}>
                                        <Tooltip title="Mark for deletion" >
                                            <IconButton
                                                disabled={disableForm}
                                                onClick={() => fields.remove(index)}>
                                                <Delete />
                                            </IconButton>
                                        </Tooltip>
                                    </FlexGridItem>
                                </Grid>
                            </FlexGridItem>
                        </FormSection>
                    )
                })}

            </>
        );
    }
}

export default UnicefOrderNoForm;